var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 32C18.5 28.9624 20.9624 26.5 24 26.5C27.0376 26.5 29.5 28.9624 29.5 32C29.5 35.0376 27.0376 37.5 24 37.5C20.9624 37.5 18.5 35.0376 18.5 32ZM24 29.5C22.6193 29.5 21.5 30.6193 21.5 32C21.5 33.3807 22.6193 34.5 24 34.5C25.3807 34.5 26.5 33.3807 26.5 32C26.5 30.6193 25.3807 29.5 24 29.5Z",
    fill: "url(#paint0_linear_26427_123574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 16C13.5 10.201 18.201 5.5 24 5.5C28.8905 5.5 33.0036 8.84484 34.1693 13.3739C34.3758 14.1762 35.1936 14.6591 35.9958 14.4527C36.7981 14.2462 37.2811 13.4284 37.0746 12.6261C35.576 6.80379 30.2925 2.5 24 2.5C16.5442 2.5 10.5 8.54416 10.5 16V18.6055C10.0463 18.6374 9.61875 18.679 9.2165 18.733C7.41628 18.9751 5.90054 19.4929 4.6967 20.6967C3.49287 21.9005 2.97508 23.4163 2.73305 25.2165C2.49993 26.9504 2.49996 29.1551 2.5 31.8902V32.1097C2.49996 34.8449 2.49993 37.0496 2.73305 38.7835C2.97508 40.5837 3.49287 42.0995 4.6967 43.3033C5.90054 44.5071 7.41628 45.0249 9.2165 45.267C10.9504 45.5001 13.1551 45.5 15.8903 45.5H32.1097C34.8449 45.5 37.0496 45.5001 38.7835 45.267C40.5837 45.0249 42.0995 44.5071 43.3033 43.3033C44.5071 42.0995 45.0249 40.5837 45.267 38.7835C45.5001 37.0496 45.5 34.8449 45.5 32.1097V31.8903C45.5 29.1551 45.5001 26.9504 45.267 25.2165C45.0249 23.4163 44.5071 21.9005 43.3033 20.6967C42.0995 19.4929 40.5837 18.9751 38.7835 18.733C37.0496 18.4999 34.8449 18.5 32.1098 18.5H15.8903C15.0432 18.5 14.2471 18.5 13.5 18.5069V16ZM9.61624 21.7063C8.14869 21.9036 7.37155 22.2645 6.81802 22.818C6.2645 23.3715 5.9036 24.1487 5.7063 25.6162C5.50319 27.1269 5.5 29.1292 5.5 32C5.5 34.8708 5.50319 36.8731 5.7063 38.3838C5.9036 39.8513 6.2645 40.6285 6.81802 41.182C7.37155 41.7355 8.14869 42.0964 9.61624 42.2937C11.1269 42.4968 13.1292 42.5 16 42.5H32C34.8708 42.5 36.8731 42.4968 38.3838 42.2937C39.8513 42.0964 40.6285 41.7355 41.182 41.182C41.7355 40.6285 42.0964 39.8513 42.2937 38.3838C42.4968 36.8731 42.5 34.8708 42.5 32C42.5 29.1292 42.4968 27.1269 42.2937 25.6162C42.0964 24.1487 41.7355 23.3715 41.182 22.818C40.6285 22.2645 39.8513 21.9036 38.3838 21.7063C36.8731 21.5032 34.8708 21.5 32 21.5H16C13.1292 21.5 11.1269 21.5032 9.61624 21.7063Z",
    fill: "url(#paint1_linear_26427_123574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26427_123574",
    x1: 24,
    y1: 2.5,
    x2: 24,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303261"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26427_123574",
    x1: 24,
    y1: 2.5,
    x2: 24,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303261"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.62602bca9c809aff58aebc0534125189.svg";
export { ForwardRef as ReactComponent };